import { Spotlight, SpotlightActionData } from "@mantine/spotlight";
import { IconSearch } from "@tabler/icons-react";

interface CommandPaletteProps {
  actions: SpotlightActionData[];
}

export function CommandPalette({ actions }: CommandPaletteProps) {
  return (
    <Spotlight
      actions={actions}
      shortcut={["mod + K"]}
      nothingFound="No results found..."
      highlightQuery
      searchProps={{
        leftSection: <IconSearch size={20} stroke={1.5} />,
        placeholder: "Search pages and actions...",
      }}
    />
  );
}
